import { createApp } from 'vue'
import router from './router'
import store from './store'
import App from './App'
import AppModal from './AppModal'

if (document.getElementById('eligibility-check')) {
  createApp(App).use(store).use(router).mount('#eligibility-check')
}

if (document.getElementById('eligibility-check-modal')) {
  createApp(AppModal).use(store).use(router).mount('#eligibility-check-modal')
}
